import { render } from "./CategoriesManagementDialog.vue?vue&type=template&id=017b2c54&ts=true"
import script from "./CategoriesManagementDialog.vue?vue&type=script&lang=ts"
export * from "./CategoriesManagementDialog.vue?vue&type=script&lang=ts"

import "./CategoriesManagementDialog.vue?vue&type=style&index=0&id=017b2c54&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__